export default {"src":"/_next/static/media/setting.3e824b3e.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};